import React from 'react'

const Loading = () => {
  return (
   <div className='w-full h-full flex'>
        <img className=' rounded w-5/6 h-5/6 m-auto' src={require("./laoder2.gif")} alt ="Loading"/>
   </div>

  )
}

export default Loading